export default "__VITE_ASSET__B8Rqu8uh__"